export const CONSTANTES = {
  RUTA: {
    basename: "",
    path: "/",
    login: "/login",
    home: "/home",
  },
  NEW_PASSWORD_REQUIRED: "NEW_PASSWORD_REQUIRED",
  CLASIF_EMP_EXTRANJERA: 'EEX',
  APIS_PATH: {
    registrarUrlProveedor: "/proveedor/ficha-url",
    obtenerFichaToken: "/proveedor/ficha-proveedor/{token}",
    actualizarFichaProveedor: "/proveedor/ficha-proveedor",
    consultarFichaProveedor: "/proveedor/ficha-proveedor/consultar",
    actualizarFichaProveedorGestion: "/proveedor/ficha-proveedor/gestion",
    finalizarFichaProveedor: "/proveedor/ficha-proveedor/finalizar",
    actualizarFichaMedioContacto: "/proveedor/ficha-medio-contacto",
    actualizarFichaFormaPago: "/proveedor/ficha-forma-pago",
    actualizarFichaTercero: "/proveedor/ficha-tercero",
    actualizarFichaPregunta: "/proveedor/ficha-pregunta",
    listarParametrosTipo: "/comunes/parametro/{tipoParametro}",
    obtenerParametroCodigo: "/comunes/parametro/{tipoParametro}/{codParametro}",
    listarPaises: "/comunes/pais",
    listarDepartamentosPais: "/comunes/departamento/{idPais}",
    listarProvinciasDep: "/comunes/provincia/{idDepartamento}",
    listarDistritosProv: "/comunes/distrito/{idProvincia}",

    
    updateUser: "usuario/actualizarUsuario",
    insertUser: "usuario/registrarUsuario",
    searchUser: "usuario/obtenerUsuario",
    getPerfil: "perfil/obtenerPerfil",
    actionsLogin: "usuario/actionsLogin",
    lockUser: "usuario/handleLoginSinExito",
    
    forgotPassword: "usuario/handleForgotPassword"
  },
};
